var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    enableBackground: "new 0 0 21 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707372",
    d: "M8.449,1.11c-4.387,0-7.944,3.557-7.944,7.944c0,4.386,3.557,7.944,7.944,7.944  c4.386,0,7.943-3.559,7.943-7.944C16.392,4.667,12.835,1.11,8.449,1.11z M8.449,15.281c-3.439,0-6.227-2.788-6.227-6.227  c0-3.439,2.788-6.227,6.227-6.227c3.439,0,6.227,2.788,6.227,6.227C14.676,12.493,11.888,15.281,8.449,15.281z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#707372",
    d: "M20.129,21.12c-0.364,0.364-0.87,0.717-1.441,0.146l-5.719-5.969c-0.571-0.57-0.179-0.793,0.186-1.157l0,0  c0.364-0.364,0.563-0.732,1.134-0.161l6.024,5.6C20.884,20.149,20.493,20.756,20.129,21.12L20.129,21.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.21f5ed5fac3414d8b0d74fba05c1b9c5.svg";
export { ForwardRef as ReactComponent };